import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowRight, Facebook, Instagram, Linkedin, Youtube } from "lucide-react";
import { Button } from "./ui/button";
import Logo from "./Logo";
import { company, nav, services } from "../data/mock";

const Footer = () => {
  return (
    <footer className="bg-slate-950 text-slate-400">
      {/* CTA strip */}
      <div className="mx-auto max-w-7xl px-6">
        <div className="relative -mt-16 overflow-hidden rounded-3xl navy-gradient p-8 md:p-12 shadow-2xl">
          <div className="blob h-56 w-56 bg-blue-500 -right-10 -top-10" />
          <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="font-display text-2xl md:text-3xl font-bold text-white">
                Ready to take your business new places?
              </h3>
              <p className="mt-2 text-blue-100/80 max-w-xl">
                One free call is all it takes to get a personalized marketing plan. No obligation.
              </p>
            </div>
            <a href={company.bookingUrl} target="_blank" rel="noreferrer" className="shrink-0">
              <Button size="lg" className="bg-white text-blue-700 hover:bg-blue-50 font-bold text-base group">
                Schedule a Call Today
                <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
              </Button>
            </a>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-6 pt-16 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Logo light />
            <p className="mt-5 text-sm leading-relaxed text-slate-400">
              A complete platform of digital marketing services for US-based businesses of every size — all under one roof.
            </p>
            <div className="mt-5 flex gap-3">
              {[Facebook, Instagram, Linkedin, Youtube].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  className="flex h-9 w-9 items-center justify-center rounded-lg bg-slate-800 text-slate-300 hover:bg-blue-600 hover:text-white transition-colors"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-display text-white font-semibold mb-4">Menu</h4>
            <ul className="space-y-2.5 text-sm">
              {nav.map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="hover:text-blue-400 transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-white font-semibold mb-4">Services</h4>
            <ul className="space-y-2.5 text-sm">
              {services.map((s) => (
                <li key={s.slug}>
                  <Link to="/services" className="hover:text-blue-400 transition-colors">
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-white font-semibold mb-4">Get In Touch</h4>
            <ul className="space-y-3.5 text-sm">
              <li>
                <a href={company.phoneHref} className="flex items-start gap-3 hover:text-blue-400 transition-colors">
                  <Phone className="h-4 w-4 mt-0.5 text-blue-400 shrink-0" /> {company.phone}
                </a>
              </li>
              <li>
                <a href={company.emailHref} className="flex items-start gap-3 hover:text-blue-400 transition-colors">
                  <Mail className="h-4 w-4 mt-0.5 text-blue-400 shrink-0" /> {company.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 mt-0.5 text-blue-400 shrink-0" />
                <span>
                  {company.address.line1}<br />
                  {company.address.line2}<br />
                  {company.address.country}
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-slate-500">
          <p>© {new Date().getFullYear()} {company.legal}. All rights reserved.</p>
          <p>Little Rock, Arkansas • Serving businesses nationwide</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
